// extracted by mini-css-extract-plugin
export default {"banner":"banner__kBGx83g69ps0_mfECUYC","title":"title___40jUpFGRWRbzM79LxpA","text":"text__vQYN6Q8tX6lxBWnERz2i"};